import PropTypes from "prop-types";
import React from "react";
import messages from "components/messagesDescription";
import { Link } from "react-router-dom";
import { DataTable } from "@cxagroup/casper";
import { Button } from "cxa-components";
import { intlShape } from "react-intl";

const Dependants = ({
  dependantListDTO,
  isCreationAllowed,
  intl,
  profileNoteForDisplay,
  formatValue,
}) => {
  const { dependants, fields } = dependantListDTO;

  if (!dependants) {
    return null;
  }

  const isEditable = fields.some(field => !field.disabled);

  const headers = fields.map(field =>
    intl.formatMessage({
      id: (field.displayName || "").trim(),
      defaultMessage: field.displayName,
    })
  );

  if (isEditable) {
    headers.push("");
  }

  const rows = dependants.map(dependant => {
    const items = fields.map(field =>
      formatValue(dependant.data[field.id], field, intl)
    );
    if (isEditable) {
      items.push(
        <Link
          className="c-action"
          to={`/dependants/${dependant.dependantKey}/edit`}
        >
          {intl.formatMessage(messages.editDescription)}
        </Link>
      );
    }
    return items;
  });

  return (
    <div>
      <h2>
        {intl.formatMessage(messages.mydependantsDescription)}
      </h2>
      <div className="u-overflow">
        <DataTable headers={headers} rows={rows} />
      </div>
      {isCreationAllowed &&
        <p>
          <Button primary to="/dependants/add">
            {intl.formatMessage(messages.addTextDescription)}
          </Button>
        </p>}
      <div
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({
            id: profileNoteForDisplay,
            defaultMessage: profileNoteForDisplay,
          }),
        }}
      />
    </div>
  );
};

Dependants.propTypes = {
  dependantListDTO: PropTypes.object,
  isCreationAllowed: PropTypes.bool,
  dependants: PropTypes.any,
  profileNoteForDisplay: PropTypes.string,
  shouldDisplayDependant: PropTypes.bool,
  intl: intlShape.isRequired,
  formatValue: PropTypes.func,
};

export default Dependants;



// WEBPACK FOOTER //
// ./components/employee/Dependants.js